module.exports = ".confirm-button {\n  background-color: #44bd32;\n  border: none;\n  color: #FFF; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialog/dialog.component.scss
// module id = ./src/app/components/dialog/dialog.component.scss
// module chunks = main